import React, {useState, useEffect}  from 'react';
import {Container, Alert, Table, Button} from 'react-bootstrap';
import {useNavigate, useParams, Link} from 'react-router-dom';
import axios from 'axios';
import {apiUrl} from '../../util/Api';
//import {isAuthenticated} from '../../util/Auth';
import {useSelector} from 'react-redux';
import {getUserAccounts} from '../../app/slices/UserSlice';

const CreateButton = (props) => {
  if(props.currRoleId > 1) {
    if(props.atLimit){
      //font-weight-light
      return (
        <div className='mb-3'>
          <Button href={`/account/${props.accountKey}/experiments/create`}  disabled>Create Experiment</Button>
          <span className='text-muted small '> the limit has been reached. upgrade your account to add more</span>
        </div>
      )
    }else {
      return (
        <div className='mb-3'>
          <Button href={`/account/${props.accountKey}/experiments/create`}  >Create Experiment</Button>
        </div>
      )
    }
  }
  else {
    return null;
  }
}

const ExperimentList = () => {

  const [errors, setErrors] = useState([]);
  const [experiments, setExperiments] = useState([]);
  const [atLimit, setAtLimit] = useState(false);

  const [showWelcome, setShowWelcome] = useState(false);

  let navigate = useNavigate();

  let {accountKey} = useParams();

  const currUserAccounts = useSelector(getUserAccounts);
  const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
  const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

  useEffect(() => {
    document.title = `reconify experiments`;
    //is an account selected?
    let options = {
      accountKey: accountKey
    }
    let isAuthError = false;
    /*
    axios.post(apiUrl + '/experiments/list',
      options, {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        if(Array.isArray(res.data.experiments)){
          setExperiments(res.data.experiments);
          if(res.data.experiments.length >= currUserAccount.experimentLimit){
            setAtLimit(true)
          }
        }
        else {
          //need to show a message to create an experiment
        }
      } else {
        let errorMsgs = [];
        let redirectToLogin = false;
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'auth-expired':
            case 'auth-error':
            case 'no-auth':
            case 'no-valid-account':
            case 'no-permissions':
              //console.log('auth expired');
              isAuthError = true;
              //navigate('/login');
              //errorMsgs.push('You have been logged out.');
              //return;
              redirectToLogin = true;
              break;
            case 'no-results':
              //console.log('no results')
              setShowWelcome(true)
              break;
            default:
              errorMsgs.push('There was an error retrieving experiments.');
          }
        });
        //don't call setErrors if not logged in as it throws an unmounted error
        if(redirectToLogin) {
          navigate('/login');
          return;
        }
        if(!isAuthError) {
          setErrors(errorMsgs);
        }
      }
    })
    .catch((err) => {
        setErrors(['There was an error retrieving experiments.']);
    });
    */
  },[navigate, accountKey, currUserAccount]);

  const sortByName = () => {
    //console.log('sorting name')
    let temp = [...experiments]
    temp.sort((a,b) => (a.name < b.name) ? -1 : 1)
    setExperiments(temp);
  }

  const sortByExperimentId = () => {
    //console.log('sorting key')
    let temp = [...experiments]
    temp.sort((a,b) => (a.experimentId < b.experimentId) ? -1 : 1)
    setExperiments(temp);
  }
  const sortByDate = () => {
    //console.log('sorting date')
    let temp = [...experiments]
    temp.sort((a,b) => (a.created < b.created) ? 1 : -1)
    setExperiments(temp);
  }

  return (
    <Container fluid>
        <div>
          <h3>Experiments</h3>
          {
            showWelcome ? (
              currRoleId > 1 ? (
              <Alert>
                Add an experiment to the account to get started.  
              </Alert>
              ) : (
                <Alert variant='danger'>
                Contact the account owner to add an experiment  
                </Alert>
              )
              
            ) : (null)
          }
          <CreateButton currRoleId={currRoleId} atLimit={atLimit} accountKey={accountKey}/>
          {
            errors.length > 0 ? (
              <Alert variant='danger'>
              {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
              </Alert>
            ) : (null)
          }
          {
            experiments.length > 0 ? (
              <div className='chart-card'>
              <Table  hover>
                <thead>
                  <tr>
                    <th><span onClick={sortByName} role="button">Experiment</span></th>
                    <th><span onClick={sortByExperimentId} role="button">App Key</span></th>
                    <th><span onClick={sortByDate} role="button">Created</span></th>
                    <th colSpan={3}>actions</th>
                  </tr>
                </thead>
                <tbody>
                {
                  experiments.map((experiment, i) => (
                    <tr key={'experiment.' + i}>
                      <td>{experiment.name}</td>
                      <td>{experiment.experimentId}</td>
                      <td>{new Date(experiment.created).toLocaleDateString()} {/*new Date(app.created).toLocaleTimeString()*/}</td>
                      <td><Link to={`/account/${accountKey}/experiments/detail/${experiment.experimentId}`} className='btn btn-secondary btn-sm' >details</Link></td>
                      
                    </tr>
                  ))
                }
                </tbody>
              </Table>
              </div>
            ) : (
              null
            )
          }
        </div>


    </Container>
  )
}

export default ExperimentList;
